import React from "react";
import { EmptyState } from "@/components/common";
import { Badge } from "@/components/ui/badge";
import { fmtNum, timeAgo } from "@/lib/format";
import { TrendingUp, TrendingDown, Repeat, History } from "lucide-react";

export const AlertsHistoryList = ({ history, loading, t }) => {
  if (loading) return <EmptyState title="..." />;
  if (history.length === 0) {
    return <EmptyState title="No triggered alerts yet" hint="Alerts that fire will be logged here." testid="alerts-history-empty" />;
  }
  return (
    <div className="space-y-2.5" data-testid="alerts-history-list">
      {history.map((e) => {
        const up = e.direction === "above";
        return (
          <div key={e.id} className="rounded-lg border p-3 flex items-center gap-3" data-testid={`alert-event-${e.id}`}>
            <div className={`h-9 w-9 rounded-lg flex items-center justify-center shrink-0 ${up ? "bg-emerald-500/15" : "bg-red-500/15"}`}>
              {up ? <TrendingUp className="h-4 w-4 text-emerald-600" /> : <TrendingDown className="h-4 w-4 text-red-600" />}
            </div>
            <div className="min-w-0 flex-1">
              <div className="flex items-center gap-2">
                <span className="font-medium text-sm">{e.symbol}</span>
                <Badge variant="secondary" className="text-[10px]">{t(`alr_type_${e.alert_type}`)}</Badge>
                {e.recurring && (
                  <Badge variant="outline" className="text-[10px] gap-0.5"><Repeat className="h-3 w-3" /></Badge>
                )}
              </div>
              <div className="text-xs text-muted-foreground truncate">{e.message}</div>
            </div>
            <div className="text-end shrink-0">
              <div className="numeric font-semibold text-sm">{fmtNum(e.price)}</div>
              <div className="text-[11px] text-muted-foreground">{timeAgo(e.timestamp)}</div>
            </div>
          </div>
        );
      })}
    </div>
  );
};
